import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";


export default function Footer() {
  const {t} = useTranslation();
  const currentYear = new Date().getFullYear();
  return (
    <footer
      style={{ minHeight: "80px" }}
      className="relative w-full flex items-center bg-primary site-footer">
      <div className="w-full md:flex md:justify-between md:items-center text-xs sm:text-sm 1smd:text-base">
        <p className="text-footerText text-center pb-2 md:text-left md:pb-0">
          {t('copyright')} © {currentYear} Milestones Page. All Rights Reserved.
        </p>
        <div className="flex flex-col text-center w-full md:w-fit xxs:flex-row xxs:space-x-2 sm:space-x-5 justify-center">
          <div onClick={()=>window.location.href="https://milestonespage.com/terms-and-conditions/"} className="text-footerText cursor-pointer">
            {t('termsConditions')}
          </div>
          <p className="hidden xxs:block text-footerText">|</p>
          <div onClick={()=>window.location.href="https://milestonespage.com/privacy-policy/"} className="text-footerText cursor-pointer">
            {t('privacyPolicy')}
          </div>
          <p className="hidden xxs:block text-footerText">|</p>
          <div onClick={()=>window.location.href="https://milestonespage.com/faqs/"} className="text-footerText cursor-pointer">
            {t('fAQ')}
          </div>
        </div>
      </div>
    </footer>
  );
}
